import React from 'react';
import PropTypes from 'prop-types';
import { BsChevronRight } from 'react-icons/bs';
import CardHeader from '../../card-header';
import Input from '../../input';
import styles from '../styles/person-relationship-card.module.css';
import { EventIcon } from '../../icon/icon';

const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
};

const Event = ({ properties, headerText }) => {
  const {
    name,
    eventType,
    venue,
    location,
    registrationDate,
  } = properties;

  return (
    <div className={styles.card}>
      <CardHeader value={headerText} icon={<EventIcon />} />
      <div className={styles.content}>
        <div className={styles.content_header}>
          <div className={styles.left_section}>
            <div className={styles.name}>
              <h2 className={styles.name_desc}>{name || 'Unknown Event'}</h2>
              <BsChevronRight className={styles.name_icon} />
            </div>
            {eventType && (
              <div className={styles.person_details_wrapper}>
                <div className={styles.person_details_title}>Type:</div>
                <div className={styles.person_details_value}>{eventType}</div>
              </div>
            )}
            {venue && (
              <div className={styles.person_details_wrapper}>
                <div className={styles.person_details_title}>Venue:</div>
                <div className={styles.person_details_value}>{venue}</div>
              </div>
            )}
            {location && (
              <div className={styles.person_details_wrapper}>
                <div className={styles.person_details_title}>Location:</div>
                <div className={styles.person_details_value}>{location}</div>
              </div>
            )}
          </div>
        </div>
        {registrationDate && (
          <div className={styles.giving_prospect_status}>
            <div className={styles.split_wrapper}>
              <Input value={formatDate(registrationDate)} label="Registration Date" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Event.propTypes = {
  properties: PropTypes.object.isRequired,
  headerText: PropTypes.string,
};

export default Event;
